<template>
    <div class="more-info-products">
        <h3>¿No encuentras el producto que buscas?</h3>
        <p>Escribenos al whatsapp y te ayudaremos a encontrar el producto que buscas.</p>
        <div class="more-info-products__form">
            <button @click="redirectWhatsapp"> 
                <FontAwesomeIcon :icon="faWhatsapp" />
                Cotizar
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

function redirectWhatsapp() {
    window.open('https://api.whatsapp.com/send?phone=51998247832', '_blank', 'noopener,noreferrer');
}

</script>

<style lang="scss" scoped>
.more-info-products {
    margin-top: 120px;
    text-align: center;
    padding-block: 50px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 10px rgba(243, 243, 243, 0.1);
    
    h3 {
        margin-bottom: 10px;
        font-size: 1.5em;
        color: $shade1;
    }

    p {
        margin-bottom: 20px;
        color: $shade1;
        opacity: 0.5;
    }

    .more-info-products__form {
        display: flex;
        justify-content: center;

        button {
            background-color: $colorPrimary;
            color: $whited;
            border: none;
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &:hover {
                background-color: $tint1;
            }

            svg {
                margin-right: 8px;
            }
        }
    }
}
</style>